export enum EAdminAuthQueryKey {
  ADMIN_AUTH_DETAILS = 'admin-auth-details',
}
